/*
 * Maison Brogi — Scent Profile quiz (port of the original React page iW / eW / rW / sW / lk).
 * Markup is fully server-rendered by sections/scent-profile-quiz.liquid; this file switches views,
 * runs the question transitions, scores the answers (original `nW`) and animates the result bars.
 */
(function () {
  if (customElements.get('scent-profile')) return;

  var EASE = 'cubic-bezier(0.25,0.1,0.25,1)';
  // Class sets toggled from JS (kept literal so Tailwind generates them).
  var ANSWER_ON = 'border-foreground bg-foreground/10 text-foreground';
  var ANSWER_OFF = 'border-foreground/10 text-muted-foreground hover:border-foreground/30 hover:text-foreground';
  var MODE_ON = 'border-foreground/30 text-foreground bg-foreground/5';
  var MODE_OFF = 'border-transparent text-muted-foreground/40 hover:text-muted-foreground';

  function reduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function setClasses(el, on, offList) {
    offList.split(' ').forEach(function (c) { el.classList.remove(c); });
    on.split(' ').forEach(function (c) { el.classList.add(c); });
  }
  function $$(sel, ctx) { return Array.prototype.slice.call(ctx.querySelectorAll(sel)); }

  /** Parse "fresh, clean, bold:2" → [{tag:'fresh', w:1}, …] */
  function parseTags(str) {
    return String(str || '').split(',').map(function (t) {
      t = t.trim().toLowerCase();
      if (!t) return null;
      var m = t.match(/^(.*?)\s*[:*]\s*(-?\d+(?:\.\d+)?)$/);
      return m ? { tag: m[1], w: parseFloat(m[2]) } : { tag: t, w: 1 };
    }).filter(Boolean);
  }

  /** Restart the global data-reveal animations inside a freshly shown element. */
  function replayReveals(root) {
    if (window.Brogi && Brogi.initReveal) Brogi.initReveal(root);
    var els = $$('[data-reveal]', root);
    if (root.hasAttribute('data-reveal')) els.unshift(root);
    els.forEach(function (el) { el.classList.remove('is-revealed'); });
    void root.offsetWidth;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        els.forEach(function (el) { el.classList.add('is-revealed'); });
      });
    });
  }
  function showRevealed(root) {
    var els = $$('[data-reveal]', root);
    if (root.hasAttribute('data-reveal')) els.unshift(root);
    els.forEach(function (el) { el.classList.add('is-revealed'); });
  }

  /** Mood bars (lk): animate width from `from[i]` (default 0) to value, with the bar's delay. */
  function animateBars(root, from) {
    var bars = $$('[data-sp-bar]', root);
    bars.forEach(function (bar, i) {
      var v = parseFloat(bar.getAttribute('data-sp-bar')) || 0;
      var start = from && from[i] != null ? from[i] : 0;
      if (reduced()) { bar.style.transition = 'none'; bar.style.width = v + '%'; return; }
      bar.style.transition = 'none';
      bar.style.width = start + '%';
    });
    if (!bars.length || reduced()) return;
    void root.offsetWidth;
    requestAnimationFrame(function () {
      bars.forEach(function (bar) {
        var v = parseFloat(bar.getAttribute('data-sp-bar')) || 0;
        var d = parseFloat(bar.getAttribute('data-sp-bar-delay')) || 0;
        bar.style.transition = 'width 0.8s ' + EASE + ' ' + d + 's';
        bar.style.width = v + '%';
      });
    });
  }

  class ScentProfile extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.views = {};
      $$('[data-sp-view]', this).forEach(function (v) { this.views[v.getAttribute('data-sp-view')] = v; }, this);
      this.questions = $$('[data-sp-question]', this);
      this.profiles = $$('[data-sp-profile]', this);
      this.progress = this.querySelector('[data-sp-progress]');
      this.stepEl = this.querySelector('[data-sp-step]');
      this.backBtn = this.querySelector('[data-sp-back]');
      this.toggle = this.querySelector('[data-sp-toggle]');
      this.view = 'intro';
      this.reset();

      this.addEventListener('click', this.onClick.bind(this));
      this._onSelect = this.onBlockSelect.bind(this);
      document.addEventListener('shopify:block:select', this._onSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this._onSelect);
      clearTimeout(this._t);
    }

    reset() {
      this.index = 0;
      this.answers = {}; // question index → array of answer numbers (strings)
      this.busy = false;
      this.result = null;
      this.mode = 'everyday';
      this.questions.forEach(function (q) { this.renderSelection(q, []); }, this);
    }

    show(name) {
      Object.keys(this.views).forEach(function (k) {
        this.views[k].classList.toggle('hidden', k !== name);
      }, this);
      this.view = name;
      var top = this.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: window.scrollY + top, behavior: 'auto' });
    }

    /* ------------------------------------------------------------------ events */
    onClick(e) {
      var t = e.target.closest('button');
      if (!t || !this.contains(t)) return;
      if (t.hasAttribute('data-sp-start')) return this.start();
      if (t.hasAttribute('data-sp-back')) return this.back();
      if (t.hasAttribute('data-sp-answer')) return this.select(t);
      if (t.hasAttribute('data-sp-continue')) return this.next();
      if (t.hasAttribute('data-sp-restart')) return this.restart();
      if (t.hasAttribute('data-sp-mode')) return this.setMode(t.getAttribute('data-sp-mode'));
    }

    onBlockSelect(e) {
      var el = e.target;
      if (!el || !this.contains(el)) return;
      var qi = this.questions.indexOf(el);
      if (qi > -1) {
        this.show('quiz');
        this.goTo(qi, 0, true);
        return;
      }
      var pi = this.profiles.indexOf(el);
      if (pi > -1) {
        this.result = { primary: this.profiles[pi], secondary: null };
        this.mode = 'everyday';
        this.renderResult(false);
      }
    }

    /* ------------------------------------------------------------------ flow */
    start() {
      if (!this.questions.length) return;
      this.reset();
      this.show('quiz');
      if (this.progress) { this.progress.style.transition = 'none'; this.progress.style.width = '0%'; void this.progress.offsetWidth; this.progress.style.transition = 'width 0.4s ease-out'; }
      this.goTo(0, 1, true);
    }

    restart() {
      this.reset();
      this.show('intro');
      replayReveals(this.views.intro);
    }

    current() { return this.questions[this.index]; }

    isMulti(q) { return q.getAttribute('data-multi') === 'true'; }

    select(btn) {
      var q = btn.closest('[data-sp-question]');
      if (q !== this.current() || this.busy) return;
      var id = btn.getAttribute('data-sp-answer');
      var i = this.index;
      if (this.isMulti(q)) {
        var cur = this.answers[i] || [];
        if (btn.hasAttribute('data-exclusive')) {
          cur = [id];
        } else {
          var excl = $$('[data-sp-answer][data-exclusive]', q).map(function (b) { return b.getAttribute('data-sp-answer'); });
          cur = cur.filter(function (x) { return excl.indexOf(x) === -1; });
          cur = cur.indexOf(id) > -1 ? cur.filter(function (x) { return x !== id; }) : cur.concat(id);
        }
        this.answers[i] = cur;
        this.renderSelection(q, cur);
      } else {
        this.answers[i] = [id];
        this.renderSelection(q, [id]);
        this.busy = true;
        var self = this;
        this._t = setTimeout(function () {
          self.busy = false;
          self.next();
        }, 400);
      }
    }

    next() {
      if (this.index < this.questions.length - 1) this.goTo(this.index + 1, 1);
      else this.complete();
    }

    back() {
      if (this.index > 0 && !this.busy) this.goTo(this.index - 1, -1);
    }

    renderSelection(q, selected) {
      $$('[data-sp-answer]', q).forEach(function (b) {
        var on = selected.indexOf(b.getAttribute('data-sp-answer')) > -1;
        if (on) setClasses(b, ANSWER_ON, ANSWER_OFF); else setClasses(b, ANSWER_OFF, ANSWER_ON);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var c = q.querySelector('[data-sp-continue]');
      if (c) {
        var ok = selected.length > 0;
        c.disabled = !ok;
        c.style.opacity = ok ? '1' : '0.3';
      }
    }

    /** AnimatePresence mode="wait": old question exits, then the new one enters (0.4s each). */
    goTo(to, dir, instantOut) {
      var self = this;
      var from = this.current();
      var target = this.questions[to];
      if (!target) return;
      var total = this.questions.length;
      this.index = to;
      if (this.stepEl) this.stepEl.textContent = to + 1;
      if (this.backBtn) this.backBtn.classList.toggle('hidden', to === 0);
      if (this.progress) {
        var w = ((to + 1) / total) * 100 + '%';
        requestAnimationFrame(function () { self.progress.style.width = w; });
      }
      this.renderSelection(target, this.answers[to] || []);

      var enter = function () {
        self.questions.forEach(function (q) { if (q !== target) { q.classList.add('hidden'); q.style.cssText = ''; } });
        target.classList.remove('hidden');
        var c = target.querySelector('[data-sp-continue]');
        if (reduced()) { target.style.cssText = ''; self.busy = false; return; }
        target.style.transition = 'none';
        target.style.opacity = '0';
        target.style.transform = 'translateX(' + (dir >= 0 ? 80 : -80) + 'px)';
        if (c) { var o = c.style.opacity; c.style.transition = 'none'; c.style.opacity = '0'; void c.offsetWidth; c.style.transition = ''; c.style.opacity = o; }
        void target.offsetWidth;
        target.style.transition = 'opacity 0.4s ' + EASE + ', transform 0.4s ' + EASE;
        target.style.opacity = '1';
        target.style.transform = 'translateX(0)';
        self.busy = false;
      };

      this.busy = true;
      clearTimeout(this._t);
      if (!from || from === target || from.classList.contains('hidden') || instantOut || reduced()) return enter();
      from.style.transition = 'opacity 0.4s ' + EASE + ', transform 0.4s ' + EASE;
      from.style.opacity = '0';
      from.style.transform = 'translateX(' + (dir >= 0 ? -80 : 80) + 'px)';
      this._t = setTimeout(enter, 400);
    }

    /* ------------------------------------------------------------------ scoring (nW) */
    score() {
      var picked = []; // [{tag, w}]
      this.questions.forEach(function (q, i) {
        var weight = parseFloat(q.getAttribute('data-weight'));
        if (isNaN(weight)) weight = 1;
        (this.answers[i] || []).forEach(function (id) {
          var b = q.querySelector('[data-sp-answer="' + id + '"]');
          if (!b) return;
          parseTags(b.getAttribute('data-tags')).forEach(function (t) { picked.push({ tag: t.tag, w: t.w * weight }); });
        });
      }, this);

      var ranked = this.profiles.map(function (p, order) {
        var match = parseTags(p.getAttribute('data-match-tags')).map(function (t) { return t.tag; });
        var s = 0;
        picked.forEach(function (t) { if (match.indexOf(t.tag) > -1) s += t.w; });
        return { el: p, score: s, order: order };
      });
      ranked.sort(function (a, b) { return b.score - a.score || a.order - b.order; });
      if (!ranked.length) return null;
      return {
        primary: ranked[0].el,
        secondary: ranked.length > 1 && ranked[1].score > 0 ? ranked[1].el : null
      };
    }

    complete() {
      this.busy = false;
      this.result = this.score();
      this.mode = 'everyday';
      if (!this.result) return this.restart();
      this.renderResult(true);
      try {
        document.dispatchEvent(new CustomEvent('brogi:scent-profile-result', {
          detail: {
            primary: this.result.primary.getAttribute('data-name'),
            secondary: this.result.secondary ? this.result.secondary.getAttribute('data-name') : null
          }
        }));
      } catch (err) { /* noop */ }
    }

    /* ------------------------------------------------------------------ result (sW) */
    renderResult(animate) {
      var r = this.result;
      this.show('result');
      var active = this.mode === 'evening' && r.secondary ? r.secondary : r.primary;
      this.profiles.forEach(function (p) {
        p.classList.toggle('hidden', p !== active);
        $$('[data-sp-discovery]', p).forEach(function (d) { d.classList.toggle('hidden', !r.secondary); });
      });
      if (this.toggle) {
        this.toggle.classList.toggle('hidden', !r.secondary);
        this.renderModeButtons();
      }
      if (animate) {
        replayReveals(this.views.result);
      } else {
        showRevealed(this.views.result);
      }
      animateBars(active);
    }

    renderModeButtons() {
      var mode = this.mode;
      $$('[data-sp-mode]', this.toggle).forEach(function (b) {
        var on = b.getAttribute('data-sp-mode') === mode;
        if (on) setClasses(b, MODE_ON, MODE_OFF); else setClasses(b, MODE_OFF, MODE_ON);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    /** Switching everyday/evening keeps the layout mounted: text swaps, bars glide to the new values. */
    setMode(mode) {
      var r = this.result;
      if (!r || mode === this.mode) return;
      var prev = this.mode === 'evening' && r.secondary ? r.secondary : r.primary;
      var from = $$('[data-sp-bar]', prev).map(function (b) { return parseFloat(b.style.width) || 0; });
      this.mode = mode;
      var active = mode === 'evening' && r.secondary ? r.secondary : r.primary;
      this.profiles.forEach(function (p) { p.classList.toggle('hidden', p !== active); });
      showRevealed(active);
      this.renderModeButtons();
      animateBars(active, from);
    }
  }

  customElements.define('scent-profile', ScentProfile);
})();
